export enum SUB_CATEGORY_OPTION_TYPE {
  personalArea = 1,
  digitalForm = 2,
  website = 3,
}
